export const INPUT_FIELDS = {
  Hidden: "ContentfulFormInputFieldHidden",
  Select: "ContentfulFormInputFieldSelect",
  SideBySide: "ContentfulFormInputFieldSideBySide",
  Text: "ContentfulFormInputFieldText",
}
